import AppUserManager from "global/appUsers/AppUserManager";
import { ElementContext } from "global/cnr/contexts/ElementContext";
import { FileManagementProvider } from "global/cnr/contexts/FileManagementContext";
import { FrameworkContext } from "global/cnr/contexts/FrameworkContent";
import { ParentContext } from "global/cnr/contexts/ParentContext";
import { UiItemContext } from "global/cnr/contexts/UiItemContext";
import { useAppUserAccess } from "global/cnr/contexts/useHelpers/useAppUserAccess";
import { showTypes_longPress, useItemSquares } from "global/cnr/contexts/useHelpers/useItemSquares";
import { useSettings } from "global/cnr/contexts/useHelpers/useSettings";
import { convertHelpers } from "global/common/convert";
import ImageGallery from "global/components/imaging/ImageGallery";
import AppUserProfilePagesWithProvider from "global/components/user/AppUserProfileItems";
import JsonViewer from "global/components/viewers/JsonViewer";
import { fullPageTypes } from "global/enums/allPageTypes";
import { clickOriginTypes, gEnums } from "global/enums/globalEnums";
import ModalOverlay from "global/page/ModalOverlay";
import { UiConnections } from "global/pageItem/modification/dataModifications/UiConnections";
import { _gamificationTypes, UiGamification } from "global/pageItem/modification/dataModifications/UiGamification";
import { UiInteractions } from "global/pageItem/modification/dataModifications/UiInteractions";
import QrCode from "global/pageItem/modification/pageItemActions/QrCode";
import UiItemAction from "global/pageItem/modification/UiItemAction";
import AppSettingsSidebarWithProvider from "global/viewSettings/AppSettingsSidebar";
import { CreateEventWithProvider } from "global/viewSettings/create/addSubs/CreateEvent";
import AppDataSidebar from "global/viewSettings/data/AppDataSidebar";
import { openExternal } from "global/viewSettings/helpers/settingsLinks";
import _ from "lodash";
import { useContext, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from 'semantic-ui-react';
import FullPageWrapper from "./FullPageWrapper";
import ItemMenuSquares from "./ItemMenuSquares";
import { _longPressDisplayTypes, _longPressTypes } from "./LongPressWrapper";
import { SquaresLongPress } from "./SquaresLongPress";
import usePageNavigation from "global/cnr/contexts/useHelpers/usePageNavigation";

const LongPressModal = ({
  apn,
  handleCancel,
  itemData,
  longPressType,
  longPressDisplayType,
  longPressModal,
  items_state
}) => {

  // used for profile
  const navigate = useNavigate();

  const upn = usePageNavigation()

  const parentContext = useContext(ParentContext);
  const { states, handlers } = parentContext ?? {}
  const { appUser_state, paps_state, currentSettings_state } = states
  const { appUser_handlers } = handlers ?? {}
  const { aps_global, aps_appUserSettings } = _.get(currentSettings_state, 'gvviSettings', {});
  const { pathViews, view, rootPath } = paps_state ?? {}
  const { isClone } = appUser_state ?? {}

  const { actions_image } = useItemSquares()

  const {
    appUserCollection,
    allowCloning,
    appUserViewTypeProp,
  } = aps_appUserSettings ?? {};

  let _allowCloning = false
  let _allowAppUserMods = false

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state, framework_handlers } = frameworkContext ?? {}
  const { frameworkRef } = framework_state ?? {}
  const { handleClick_contentItem } = framework_handlers ?? {}

  // uiItemContext
  const uiItemContext = useContext(UiItemContext);
  const { item_state, item_handlers } = uiItemContext ?? {}

  const _item_state = items_state || item_state
  const { viewItem, viewItem_key: viKey } = _item_state ?? {}

  if (viKey === appUserCollection) {
    _allowCloning = allowCloning
    _allowAppUserMods = true
  }

  // elementContext
  const elementContext = useContext(ElementContext)
  const { element_state } = elementContext ?? {}
  const { itemData: itemData_elem } = element_state ?? {}

  const _itemData = itemData || itemData_elem

  const { _itemKey } = itemData ?? {}

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { appUserSessionKey } = appUserSession ?? {}

  const settings_fns = useSettings()
  const _appUserAccess = useAppUserAccess()

  const access = useMemo(() => {
    if (!appUserAccess) { return {} }
    const _access = {
      appProfile: { allowed: appUserAccess.accessLevel >= gEnums.allAuthLevels.appProfile.value, color: gEnums.allAuthLevels.appProfile.color },
      auth: { allowed: appUserAccess.accessLevel >= gEnums.allAuthLevels.superAdmin.value, color: gEnums.allAuthLevels.superAdminDeveloper.color },
      data: { allowed: appUserAccess.accessLevel >= gEnums.allAuthLevels.appDataAdmin.value, color: gEnums.allAuthLevels.appDataAdmin.color },
      settings: { allowed: appUserAccess.accessLevel >= gEnums.allAuthLevels.appAdmin.value, color: gEnums.allAuthLevels.appAdmin.color },
      appSettings: { allowed: appUserAccess.accessLevel >= gEnums.allAuthLevels.appAdmin.value, color: gEnums.allAuthLevels.appAdmin.color },
    }
    switch (longPressType) {
      case _longPressTypes.appUser:
        _access.any = _access.auth || _access.data || _access.settings || _access.appProfile
        break;
      default:
        _access.any = _access.auth || _access.data || _access.settings
    }
    return _access
  }, [appUserAccess, longPressType])

  let name = convertHelpers.getItemName(_itemData, null, null, true)

  if (longPressModal?.header) {
    name = longPressModal.header
  }

  const [showType, setShowType] = useState()
  const [actionType, setActionType] = useState()

  const handleShowType = (showType) => setShowType(showType)
  const handleActionType = (actionType) => setActionType(actionType)
  const handleShow_qrCodeAppUser = () => handleShowType(showTypes_longPress.qrCodeAppUser)
  const handleShow_qrCodeItem = () => handleShowType(showTypes_longPress.qrCodeItem)
  const handleResetAccessLevel = () => {
    appUser_handlers.handleResetAccessLevel()
    handleCancel()
  }

  const handleSignInAs = () => {
    const actionItem = { dataActionType: 'clone', cloneId: _itemKey, cloneVit: appUserCollection, appUserViewTypeProp: appUserViewTypeProp }
    appUser_handlers.handleClone(actionItem, _itemData, paps_state, appUserCollection)
    handleCancel()
  }

  /**
   * this will trigger a change in the state of the ItemContext
   * UiItem > content={modifyActionType ? <UiItemAction /> : ui_content(useSwiper)}
   * UiItemAction
   * possibly: UiDataModifications
   * possibly: DataModificationContent
   * @param {*} dmo 
   * @param {*} dmoKey 
   */
  const handleClick_item = (dmo, dmoKey) => {
    const _key = dmo?.key || dmoKey
    const ct = { modifyActionType: _key, _modifyActionProps: { modifyItemData: itemData, modifyItemKey: _itemKey, modifyViewItemKey: viKey } }
    item_handlers.handleSet_modifyAction(ct)
    handleCancel()
  }

  const handleClick_action = (dmo, dmoKey) => {
    const _key = dmo?.key || dmoKey
    if (dmo.showType) {
      switch (dmo.showType) {
        case showTypes_longPress.openDatabase:
          openExternal.db(pathViews, null, [view, pathViews?.[view]])
          break;
        case showTypes_longPress.myProfilePage:
          navigate(`${rootPath}/attendees/${appUserSessionKey}`)
          break;
        case showTypes_longPress.setAsBanner:
          const cb_b = () => {
            handleCancel()
          }
          const _global_b = _.cloneDeep(aps_global)
          if (_global_b?.banner) {
            _global_b.banner.bannerType = gEnums.bannerTypes.fromFile
            _global_b.banner.banner = itemData.itemKey
          } else {
            _global_b.banner = {
              bannerType: gEnums.bannerTypes.fromFile,
              banner: itemData.itemKey
            }
          }
          settings_fns.updateGlobalFromSidebar(pathViews, { global: _global_b }, _appUserAccess, cb_b)
          break;
        case showTypes_longPress.setAsManifest:
          const cb_m = () => {
            handleCancel()
          }
          break;
        default:
          handleShowType(dmo.showType)
      }
    } else {
      handleActionType(_key)
      handleShowType(showTypes_longPress.itemAction)
    }
  }

  const handleClick_nav = (dmo, dmoKey) => {
    const clickedItem = { key: dmo.itemKey }
    const navProps = { clickedItem }
    if (fullPageTypes[dmo.itemKey]) {
      handleClick_contentItem(navProps)
      return;
    }
    upn.handleNav(navProps)
  }

  const handleClick_navPath = (dmo) => {
    const { key } = dmo
    switch (key) {
      case 'home':
        upn.handleNav_path('')
        break;
      case 'client':
        upn.handleNav_path('clients/' + pathViews.clients)
        break;

    }
    // 
  }

  const qrIcon = () => {
    switch (longPressType) {
      case _longPressTypes.appUser:
        return <div><Icon name='qrcode' color='blue' size={'large'} onClick={() => handleShow_qrCodeAppUser()} /></div>
      case _longPressTypes.item:
        return <div><Icon name='qrcode' color='blue' size={'large'} onClick={() => handleShow_qrCodeItem()} /></div>
      default:
        return <div></div>
      // nothing
    }
  }

  /**
   * 
   * @returns the header for the modal
   */
  const modalHeader = () => {

    const hc = () => {
      // if (isOverlay) {
      //   window.history.back();
      // } else {
      //   handleCancel()
      // }
    }

    let div0 = longPressDisplayType === _longPressDisplayTypes.partial && <div><Icon name='delete' onClick={() => hc()} /></div>;
    let div1;
    let div2;

    switch (longPressType) {
      case _longPressTypes.appUser:
        div1 = <div>{`${_.startCase(viKey)} Options: ${appUserAccess?.displayName}`}</div>
        div2 = <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1em' }}>
          {qrIcon()}
          {isClone && <div><Icon name='user delete' color='grey' size={'large'} onClick={() => handleResetAccessLevel()} /></div>}
        </div>
        break;

      default:
        if (_allowCloning) {
          div1 = <div>{`${_.startCase(viKey)} Options: ${name}`}</div>
          div2 = <div><Icon name='sign in alternate' color='blue' size={'large'} onClick={() => handleSignInAs()} /></div>
        } else {
          div1 = <div>{name ? `${_.startCase(viKey)} Options: ${name}` : `${_.startCase(viKey)} Options`}</div>
          div2 = qrIcon()
        }
    }

    // this is at the top of the moday
    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      {div0}
      {div1}
      {div2}
    </div>
  }

  /**
   * 
   * @returns the content for the modal
   */
  const squarez_content = () => <SquaresLongPress
    handleClick_action={handleClick_action}
    handleClick_item={handleClick_item}
    handleClick_nav={handleClick_nav}
    handleClick_navPath={handleClick_navPath}
    longPressType={longPressType}
    itemData={itemData}
    longPressDisplayType={longPressDisplayType}
    apn={apn}
  />

  const squares_images = () => {
    return <div className='menu-squares'>
      {access.auth.allowed && !_.isEmpty(actions_image) && <ItemMenuSquares
        fullRow={true}
        withCancel={true}
        onCancel={handleCancel}
        caption={`Image`}
        menuItems={actions_image}
        onClick={handleClick_action}
        icon={'user secret'}
      />}
    </div>
  }
  const modalContent = () => longPressModal?.content || squarez_content()

  const modal_overlay = () => <ModalOverlay
    topperCaption={apn?.caption || _.startCase(longPressType)}
    header={modalHeader()}
    content={modalContent()}
    frameworkRef={frameworkRef}
    handleCancel={handleCancel}
    closeOverlay={handleCancel}
    longPressDisplayType={longPressDisplayType}
  />

  switch (showType) {
    case showTypes_longPress.itemAction:
      return <FullPageWrapper
        topperCaption={`App User: ${appUserAccess?.displayName}`}
        handleCancel={handleShowType}
        content={<UiItemAction actionType={actionType} handleCancel={handleShowType} />}
        wrapperCss={{ container: 'app-dark-mode', content: 'padd10' }}
      />
    case showTypes_longPress.connections:
      return <UiConnections handleCancel={handleShowType} />

    case showTypes_longPress.interactions:
    case showTypes_longPress.itemInteractions:
      return <UiInteractions handleCancel={handleShowType} showType={showType} />

    case showTypes_longPress.scanAppUser:
      return <UiGamification handleCancel={handleShowType} gamificationType={_gamificationTypes.appUser} />

    case showTypes_longPress.scanItem:
      return <UiGamification handleCancel={handleShowType} gamificationType={_gamificationTypes.item} />

    case showTypes_longPress.qrCodeAppUser:
      return <QrCode handleCancel={handleShowType} itemData={appUserAccess} itemType={appUserAccess.uid} qrCodeType={gEnums.qrCodeTypes.gamificationAppUser} />

    case showTypes_longPress.qrCodeItem:
      return <QrCode handleCancel={handleShowType} itemData={_itemData} itemType={viKey} qrCodeType={gEnums.qrCodeTypes.gamificationItem} />

    case showTypes_longPress.data:
      return <JsonViewer itemData={_itemData} fullScreen={true} handleCancel={handleShowType} vit={'Data'} />

    case showTypes_longPress.viewItem:
      return <JsonViewer itemData={viewItem} fullScreen={true} handleCancel={handleShowType} vit={'View Item'} />

    case showTypes_longPress.createEvent:
      return <FullPageWrapper
        topperCaption={'Create Event'}
        content={<CreateEventWithProvider />}
        handleCancel={handleShowType}
        wrapperCss={{ container: 'app-dark-mode', content: 'padd10' }}
      />

    case showTypes_longPress.auth:
      return <AppUserManager selectedAppUser={_itemData} handleCancel={handleShowType} clickOriginType={clickOriginTypes.longpress} />

    case showTypes_longPress.appUser:
      return <FullPageWrapper
        topperCaption={`App User: ${appUserAccess?.displayName}`}
        handleCancel={handleShowType}
        content={<AppUserProfilePagesWithProvider />}
        wrapperCss={{ container: 'app-dark-mode', content: 'padd10' }}
      ></FullPageWrapper>

    case showTypes_longPress.appSettings:
    case showTypes_longPress.pageSettings:
      const vssProps = { isGlobal: showType === showTypes_longPress.appSettings ? true : false }
      return <FullPageWrapper
        topperCaption={`Settings (${_.startCase(showType)})`}
        handleCancel={handleShowType}
        content={<AppSettingsSidebarWithProvider {...vssProps} />}
        css={{ container: 'app-dark-mode' }}
      ></FullPageWrapper>

    case showTypes_longPress.appData:
      return <FullPageWrapper
        topperCaption={`Data (${_.startCase(showType)})`}
        handleCancel={handleShowType}
        content={<AppDataSidebar fromLongPress={true} />}
        css={{ container: 'app-dark-mode' }}
      ></FullPageWrapper>

    case showTypes_longPress.selectImage:
      const fileManagmentOpts = {
        fileOptionType: gEnums.fileOptionTypes.global,
        storageType: gEnums.storageTypes.image,
        allowUpload: true
      }
      return <FileManagementProvider fileManagmentOpts={fileManagmentOpts}>
        <FullPageWrapper
          topperCaption={`App User: ${appUserAccess?.displayName}`}
          handleCancel={handleShowType}
          content={<ImageGallery
            storageLocationType={gEnums.storageLocationTypes.event}
            storageType={'image'}
            fileManagementOpts={{
              fileOptionType: 'global',
              storageType: 'image'
            }}
          />
          }
          wrapperCss={{ container: 'app-dark-mode', content: 'padd10' }}
        ></FullPageWrapper >
      </FileManagementProvider>
    default:

      // determine the longPressType 
      switch (longPressType) {
        case _longPressTypes.appUser:
        case _longPressTypes.bannerImage:
        case _longPressTypes.header:
        case _longPressTypes.item:
        case _longPressTypes.match:
        case _longPressTypes.pageNav:
          return modal_overlay()
        case _longPressTypes.image_grid:
          return squares_images()
        default:
          console.log(`Long Press Type${longPressType} is not set`)
          return;
      }
  }
}

export default LongPressModal 